import { desktop, tablet } from '@styles/mixins'
import { colors } from '@styles/vars'
import React from 'react'
import styled, { css } from 'styled-components'

export default function Loading() {
    return (
        <Wrapper id="loading"><Ring /></Wrapper>
    )
}

/* COMPONENTS */
export const Ring = (props: RingProps) => {
    return (
        <RingStyles {...props}>
            <div />
            <div />
            <div />
        </RingStyles>
    )
}

// TYPES
interface RingProps {
    fill?: string
    height?: number
}

// FUNCTIONS
let loadingCounter = 0
let isLoadingWorking = true

export const startLoading = () => {
    if (loadingCounter === 0) {
        if (isLoadingWorking)
            document.getElementById('loading')?.classList.add("visible")
    }
    loadingCounter++
}

export const skipGlobalLoading = async (fn: () => Promise<any>) => {
    stopGlobalLoadingAnimation()
    const result = await fn()
    startGlobalLoadingAnimation()
    return result
}

export const stopGlobalLoadingAnimation = () => {
    isLoadingWorking = false
}

export const startGlobalLoadingAnimation = () => {
    isLoadingWorking = true
}

export const finishLoading = () => {
    loadingCounter--
    if (loadingCounter === 0)
        document.getElementById('loading')?.classList.remove("visible")
}

// STYLES
const Wrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    transition: .2s ease-out;
    opacity: 0;
    display: none;
    align-items: center;
    font-weight: 700;
    color: ${colors.black};
    z-index: 999;
    transition-delay: .2s;

    ${tablet(css`
        top: 17px;
        right: 15px;
    `)}

    ${desktop(css`
        top: 17px;
        right: 20px;
    `)}

    &.visible {
        display: flex;
        opacity: 1;
    }
`

export const RingStyles = styled.div<{ fill?: string, height?: number }>`
    display: block;
    position: relative;
    width: ${props => props.height ? props.height + 'px' : "32px"};
    height: ${props => props.height ? props.height + 'px' : "32px"};

    div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: ${props => props.height ? props.height / 1.5 + 'px' : "16px"};
        height: ${props => props.height ? props.height / 1.5 + 'px' : "16px"};
        margin: ${props => props.height ? props.height / 6 + 'px' : "8px"};
        border: ${props => props.height ? props.height / 8 + 'px' : "3px"} solid ${props => props.fill || colors.black};
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${props => props.fill || colors.black} transparent transparent transparent;
    }
    div:nth-child(1) {
        animation-delay: -0.45s;
    }
    div:nth-child(2) {
        animation-delay: -0.3s;
    }
    div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`